import * as S from './styles';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectUser } from 'redux/db/reducers';
import { shallowEqual } from 'react-redux';
import { Tooltip } from 'components/Widget/Tooltip';
import { useEffect, useState } from 'react';
import { AuthUser } from 'dragonmouse-shared/interfaces';
import { getColorFromName } from 'utils';

interface ProfileIconProps {
	size?: number;
}
const ProfileIcon = ({ size = 32 }: ProfileIconProps) => {
	const [tooltip, setTooltip] = useState('');
	const { user, authUser } = useSelector((r: RootReducer) => {
		return {
			user: selectUser(r.db),
			authUser: r.mode.authUser as AuthUser | null,
		};
	}, shallowEqual);

	const [tooltipId] = useState(String(Math.random()));

	//------------------------------------------------------------------------------------------------
	// HOOKS
	//------------------------------------------------------------------------------------------------

	// when user changes, set the tooltip
	useEffect(() => {
		const name = user?.displayName || '';
		const email = authUser?.email || '';
		if (name && email) {
			setTooltip(`${name} (${email})`);
		} else if (name) {
			setTooltip(name);
		} else if (email) {
			setTooltip(email);
		} else {
			setTooltip('');
		}
	}, [user, authUser]);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	// a bit of a hacky code to get font looking right for the sizes we use in practice
	let fontSize = 14;
	if (size < 20) fontSize = 12;
	if (size > 32) fontSize = 20;

	if (!user) {
		return null;
	}
	const displayName = user.displayName || '';
	const firstLetter = displayName.length > 0 ? displayName.charAt(0).toUpperCase() : '_';

	return (
		<>
			<S.ProfileInitial
				size={size}
				fontSize={fontSize}
				style={{ backgroundColor: getColorFromName(displayName) }}
				data-tooltip-id={tooltipId}
				data-tooltip-content={tooltip}
			>
				{firstLetter}
			</S.ProfileInitial>
			<Tooltip id={tooltipId} placement="top" />
		</>
	);
};

export default ProfileIcon;
